import React, {useContext, useEffect} from 'react';
import {useLocation} from "react-router-dom";
import IFrameWrapper from "../../components/IFrameWrapper";
import CompanyTeamContext from "../../CompanyTeamContext";
import {IFRAME_DOMAIN} from "../../utilities/Constants";

const TestReport = (props) => {
    const {search} = useLocation();
    const company = useContext(CompanyTeamContext);

    useEffect(() => {
        if (company) {
            document.title = "Performance Report - " + company.basicTitle;
            return () => {
                document.title = company.basicTitle;
            }
        }
    }, [company]);

    return (
        <IFrameWrapper src={IFRAME_DOMAIN + "/TestReport.html" + search + "&liteColor=1"} width={"min(100%, 1150px)"} />
    );
};

export default TestReport;
